<template>
  <div>
    <div class="filters">
      <div class="flex">
        <div class="filter-item">
          <span>时间选择：</span>
          <el-date-picker
            v-model="dateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :clearable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="chooseDate"
          >
          </el-date-picker>
        </div>
        <!-- <div class="filter-item">
          <span>交易类型：</span>
          <el-select v-model="dataType" placeholder="请选择">
            <el-option label="收入" value="income" />
            <el-option label="支出" value="expend" />
          </el-select>
        </div> -->
      </div>
      <div>
        <el-button type="primary" plain icon="el-icon-search" size="small" class="search-btn" @click="getTransactionRecords">查询</el-button>
        <!-- <el-button type="warning" style="border-radius: 14px" class="el-icon-download" plain> 导出明细</el-button> -->
      </div>
    </div>
    <el-table
      :show-header="false"
      :data="transactionRecords"
      v-loading="laodRecharge"
      height="calc(100vh - 350px)"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      class="balance-table"
    >
      <el-table-column>
        <template slot-scope="scope">
          <div class="item-box">
            <div class="item-icon">
              <!-- <i class="iconfont icongateway"></i> -->
              <img src="https://picture.aiyizhijian.com/image/png/647282647684809984.png" alt="" style="width: 100%; height: 100%" />
            </div>
            <div class="item-text">
              <div class="big bold">
                结算往来单据: <span style="color: #13b37c">{{ scope.row.DocumentNo ? scope.row.DocumentNo : '' }}</span>
              </div>
              <div class="small">订单单据编号:{{ scope.row.stsos_Order_number ? scope.row.stsos_Order_number : '' }}</div>
              <div class="small">{{ scope.row.Creationtime ? scope.row.Creationtime : '' }}</div>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="100" prop="currentNumber" align="left">
        <template slot-scope="scope">
          <div class="big bold text-color-success" v-if="scope.row.currentNumber > 0">+{{ scope.row.currentNumber }}</div>
          <div class="big bold text-color-danger" v-else>
            {{ scope.row.currentNumber }}
          </div>
          <div class="small">交易金额</div>
        </template>
      </el-table-column>
      <el-table-column width="150" prop="sttr_Transaction_type" align="left">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.sttr_Transaction_type }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column width="750" align="left">
        <template slot-scope="scope">
          <div>
            <span class="recharge-tip">期初金额：{{ scope.row.sttr_Opening_amount }}</span>
            <span class="recharge-tip">
              发生金额： <span v-if="scope.row.sttr_Current_amount > 0" style="color: #33c24b"> +{{ scope.row.sttr_Current_amount }} </span
              ><span v-else style="color: #e65454"> {{ scope.row.sttr_Current_amount }} </span>
            </span>
            <span class="recharge-tip"> 期末金额：{{ scope.row.sttr_Closing_amount }} </span>
          </div>
          <div>
            <span class="recharge-tip">期初E豆：{{ scope.row.sttr_Opening_points }} </span>
            <span class="recharge-tip">
              使用E豆：<span v-if="scope.row.sttr_Current_points > 0" style="color: #33c24b">{{ scope.row.sttr_Current_points }}</span>
              <span v-else style="color: #e65454">{{ scope.row.sttr_Current_points }}</span>
            </span>
            <span class="recharge-tip"> 期末E豆：{{ scope.row.sttr_Final_points }} </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '@/utils/request';
import moment from 'moment';
export default {
  name: 'BusinessData',
  data() {
    return {
      dateRange: [],
      dataType: '',
      startTime: '', //左侧时间
      endTime: '', //右侧时间
      transactionRecords: [], //往来记录
      laodRecharge: false
    };
  },
  filters: {
    sexFilter(val) {
      return val === 'male' ? '男' : val === 'female' ? '女' : '未知';
    }
  },
  created() {},
  mounted() {
    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
    this.startTime = moment(new Date().getTime() - 7000 * 60 * 60 * 24).format('YYYY-MM-DD');
    this.dateRange = [this.startTime, this.endTime];
    this.getTransactionRecords();
  },
  methods: {
    // 选择时间
    chooseDate(event) {
      if (event) {
        this.startTime = event[0];
        this.endTime = event[1];
        this.getTransactionRecords();
      } else {
        this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
        this.startTime = moment(new Date().getTime() - 7000 * 60 * 60 * 24).format('YYYY-MM-DD');
        this.getTransactionRecords();
      }
    },
    // 获取充值明细
    getTransactionRecords() {
      const that = this;
      that.laodRecharge = true;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        cal_code: clinicInfo.cal_code,
        ksdate: that.startTime,
        jsdate: that.endTime
      };
      const params = {
        token: clinicInfo.token,
        workid: '633c78c5-1363-83a0-26bd-d41c0fa30bcc',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          that.laodRecharge = false;
          that.transactionRecords = res.Settlement_transaction.reverse();
          that.transactionRecords.map((item) => {
            item.currentNumber = Number(item.sttr_Current_amount) + Number(item.sttr_Current_points);
          });
        })
        .catch((err) => {
          that.laodRecharge = false;
          that.$message.error('抱歉，往来记录查询失败');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.recharge-tip {
  display: inline-block;
  width: 200px;
  // border: 1px solid red;
}
.balance-table {
  width: 100%;
  // border: 1px solid red;
}
.filters {
  display: flex;
  margin-bottom: 15px;
  .el-date-editor {
    width: 240px;
  }
  .el-select {
    width: 120px;
  }
  .filter-item {
    margin-right: 10px;
  }
}
.item-box {
  display: flex;
  .item-icon {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 10px;
    // background-color: #5db4fc;
    margin-right: 10px;
    // align-items: center;
    // display: flex;
    // justify-content: center;
    // font-size: 80px;
    // color: #fff;

    // background-size: 30px;
    // background-repeat: no-repeat;
    // background-position: center center;
    // background-image: url(~@/assets/img/shiguan.svg);
  }
  .item-text {
    line-height: 14px;
    .bold {
      line-height: 20px;
    }
  }
}
</style>
